/**
 * @fileoverview Sentry logging utilities for the Aha! Editor.
 * Provides safe breadcrumb logging with data scrubbing to prevent sensitive data exposure.
 */

import { Scrubber } from 'slate';
import * as Sentry from '@sentry/browser';

/**
 * Adds a breadcrumb to Sentry with scrubbed data for debugging editor operations.
 * Uses Slate's Scrubber to safely stringify data before sending to Sentry.
 * @param options - Breadcrumb configuration options
 * @param options.message - Descriptive message for the breadcrumb
 * @param options.category - Category for grouping breadcrumbs (defaults to 'editor-v2')
 * @param options.data - Optional data to include, will be scrubbed before sending
 */
export const AddScrubbedSentryBreadcrumb = ({
  message,
  category = 'editor-v2',
  data,
}: Partial<Sentry.Breadcrumb>) => {
  const breadcrumb: Sentry.Breadcrumb = {
    category,
    message,
    level: 'info',
  };

  if (data) {
    breadcrumb.data = { details: Scrubber.stringify(data) };
  }

  Sentry.addBreadcrumb(breadcrumb);
};
